import { canUseGestao, hasPermission } from "../../../services/auth";
import { firstGestaoSettingsPath } from "../../../components/GestaoSettingsTabs";

/**
 * Tudo que é configurar (e não operar) mora atrás de Configurações desde o
 * menu novo (BDM-1315). Avaliado na chamada, nunca no import: as permissões
 * vêm do localStorage, que ainda está vazio antes do login.
 */
export const getSettingsSections = () => [
    {
        key: 'account',
        title: 'Conta e acesso',
        cards: [
            { icon: 'user', name: 'Usuários', description: 'Quem acessa o sistema e com qual nível.', to: '/user/list', show: hasPermission('admin') },
            { icon: 'shield-check', name: 'Níveis de acesso', description: 'O que cada nível pode ver e fazer.', to: '/role/list', show: hasPermission('role') },
            { icon: 'globe', name: 'Domínio', description: 'Endereço do site e do sistema.', to: '/settings/domain', show: hasPermission('configure_domain') },
            { icon: 'integration', name: 'Integrações', description: 'Fornecedores, ERP, webhooks e API.', to: '/integration/list', show: hasPermission('view_integration') },
        ],
    },
    {
        key: 'sales',
        title: 'Vendas',
        cards: [
            { icon: 'calculator', name: 'Cálculo de preço', description: 'Margens, variáveis e custo de gravação.', to: '/calculation', show: hasPermission('calculation') },
            { icon: 'list-checks', name: 'Status', description: canUseGestao() ? 'Etapas de orçamentos, pedidos e compras.' : 'Etapas de orçamentos e pedidos.', to: '/status/list', show: hasPermission('status') },
            { icon: 'wallet', name: 'Condições de pagamento', description: 'Prazos e formas aceitas.', to: '/settings/payment-conditions', show: hasPermission('payment_terms') },
            { icon: 'email', name: 'E-mails e PDFs', description: 'Modelos enviados ao cliente.', to: '/email-template/list', show: hasPermission('email_template') },
        ],
    },
    {
        key: 'site',
        title: 'Site',
        cards: [
            { icon: 'design', name: 'Identidade da marca', description: 'Logo, cores e favicon.', to: '/theme' },
            { icon: 'layout-template', name: 'Tema do site', description: 'Layout e aparência da vitrine.', to: '/theme/site' },
            { icon: 'search', name: 'SEO', description: 'Como o site aparece nos buscadores.', to: '/theme/seo' },
            { icon: 'order', name: 'Campos do carrinho', description: 'O que o cliente preenche no orçamento.', to: '/site/formulario-orcamento' },
            { icon: 'toggle-right', name: 'Recursos do site', description: 'Liga e desliga funções da vitrine.', to: '/site/recursos' },
            { icon: 'code', name: 'Tags e scripts', description: 'Analytics, pixels e scripts de terceiros.', to: '/scripts' },
            { icon: 'phone', name: 'Contato e mídias', description: 'Telefones, endereço e redes sociais.', to: '/contact' },
        ].map(card => ({ ...card, show: hasPermission('content') })),
    },
    {
        key: 'gestao',
        title: 'Gestão',
        module: true,
        cards: [
            {
                icon: 'sliders-horizontal',
                name: 'Cadastros e ajustes',
                description: 'Contas, plano de contas, emissão fiscal e automações.',
                to: firstGestaoSettingsPath(),
                show: canUseGestao() && !!firstGestaoSettingsPath(),
            },
        ],
    },
]
    .map(section => ({ ...section, cards: section.cards.filter(card => card.show) }))
    .filter(section => section.cards.length > 0);

// Rotas de cada card, para o item Configurações do menu continuar marcado
// dentro delas. "Cadastros e ajustes" tem item próprio na seção Gestão.
export const SETTINGS_PATHS = [
    '/user/list', '/role/list', '/settings/domain', '/integration', '/feed',
    '/calculation', '/status/list', '/settings/payment-conditions', '/email-template',
    '/theme', '/site/formulario-orcamento', '/site/recursos', '/scripts', '/contact',
];

export const canSeeSettingsHub = () => getSettingsSections().length > 0;

